import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@app/store/authStore';

export default function GuestGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, user } = useAuthStore();

  if (isAuthenticated && user) {
    const paths: Record<string, string> = {
      patient: '/patient/dashboard',
      doctor: '/clinician/dashboard',
      nurse: '/clinician/dashboard',
      physician_assistant: '/clinician/dashboard',
      pharmacist: '/pharmacy/dashboard',
      lab_tech: '/laboratory/dashboard',
      admin: '/admin/dashboard',
      super_admin: '/admin/dashboard',
    };
    return <Navigate to={paths[user.role] || '/patient/dashboard'} replace />;
  }

  return <>{children}</>;
}
